import React from 'react';
import ReactDOM from 'react-dom';

// *** VENDOR JS ***
import './vendor/presentable';

// *** OTHER ***
import './documentReady';
import './globals';
import './registerServiceWorker';

// *** FOR INITIAL AUTH CHECK ***
import AccountActions from 'actions/AccountActions.js';
import WorkspaceActions from 'actions/WorkspaceActions';

// *** STORES (initialization) ***
import 'stores/LocationsStore';
import 'stores/DepartmentsStore';
import 'stores/LoginStore';
import 'stores/OffersStore';
import 'stores/ShiftStore';
import 'stores/UnavailablesStore';
import 'stores/UnavailableTypesStore';
import 'stores/AvailabilitiesStore';
import 'stores/UserSettingsStore';
import 'stores/AccountStore';
import 'stores/TimeSheetStore';
import 'stores/UserStore';
import 'stores/BidsStore';
import 'stores/ExchangesStore';
import 'stores/NotificationsStore';
import 'stores/WorkspaceStore';
import 'stores/SelfScheduleStore';

// this will require and make all models global.
// about require.context: https://github.com/webpack/docs/wiki/context#context-module-api
const importAll = r => r.keys()
  .forEach(r);
require.context('./models', false, /\.js$/);
importAll(require.context('./models', false, /\.js$/));

// *** COMPONENTS ***
import Routes from 'routes/Routes';

// *** STYLESHEETS ***
import '../stylesheets/site.css.scss';

if (__COMPANY__ === 'adp') {
  require('../stylesheets/adp_override.css.scss');
}

if (__COMPANY__ === 'cerner') {
  require('../stylesheets/cerner_override.css.scss');
}

if (__COMPANY__ === 'jonas') {
  require('../stylesheets/jonas_override.css.scss');
}

const refreshWorkspaceConfig = () => {
  const workspaceConfig = Utils.getWorkspaceConfig();
  const workspaceId = workspaceConfig && workspaceConfig.workspace_id;
  if (workspaceId) {
    WorkspaceActions.lookupWorkspace(workspaceId);
  }
};

const renderApplication = () => {
  Utils.setLocale(Utils.getLocale());
  Utils.applyWorkspaceTheme();
  refreshWorkspaceConfig();
  ReactDOM.render(<Routes />, document.querySelector('body #reactContainer'));
};

const token = Utils.getAuthToken();
if (token && Utils.isOnline()) {
  AccountActions.checkTokenValidity(renderApplication);
} else {
  renderApplication();
}
